import React, { Component } from 'react';
import { Button, Card, DatePicker, Form, Select, Spin } from 'antd';
import moment from 'moment';
import { fetchData } from '../../../lib/apis';
import { AccountMetaData } from '../../../config/settings';
import config from '../../../lib/config';

const { RangePicker } = DatePicker;
const { Option } = Select;

const getEnv = (key) => {
	return (window._env_ && window._env_[key]) || process.env[key];
};

const getChannelMeta = (channel = {}) => {
	const accType = Number(channel.acc_type);
	return config.type_account_social[accType] || {};
};

const getChannelName = (channel = {}) => channel.alias || channel.full_name || channel.username || channel.user_id;

export default class ExportChatTxtView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			channels: [],
			loading: false,
			loadingChannels: false
		};
	}

	componentDidMount = () => {
		this.getChannels();
	}

	getChannels = async () => {
		try {
			this.setState({ loadingChannels: true });
			const res = await fetchData({
				url: 'api/v1/chat/channel/list'
			});
			this.setState({
				channels: Array.isArray(res.data) ? res.data : [],
				loadingChannels: false
			});
		} catch (err) {
			this.setState({ loadingChannels: false });
			this.props.notification({
				title: 'Tải danh sách kênh',
				content: err.message || 'Không thể tải danh sách kênh',
				type: 'error'
			});
		}
	}

	downloadBlob = async (url) => {
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: `${AccountMetaData.getToken()}`,
				Company: AccountMetaData.getCompanyId()
			},
			credentials: 'include'
		});

		if (!response.ok) {
			let errorMessage = 'Xuất file thất bại';
			try {
				const errorJson = await response.json();
				errorMessage = errorJson.message || errorMessage;
			} catch (e) {}
			throw new Error(errorMessage);
		}

		const blob = await response.blob();
		const disposition = response.headers.get('content-disposition') || '';
		const matched = disposition.match(/filename="?([^\"]+)"?/i);
		const fileName = matched && matched[1] ? matched[1] : 'chat-export.txt';
		const blobUrl = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = blobUrl;
		link.download = fileName;
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.URL.revokeObjectURL(blobUrl);
	}

	renderChannelOption = (item) => {
		const meta = getChannelMeta(item);
		const iconSrc = meta.icon ? (typeof meta.icon === 'object' ? meta.icon.default || meta.icon : meta.icon) : '';
		const channelName = getChannelName(item);
		const channelType = meta.name || 'Khác';

		return (
			<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
				<div style={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
					{iconSrc ? <img src={iconSrc} alt={channelType} style={{ width: 24, height: 24, objectFit: 'contain' }} /> : null}
				</div>
				<div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
					<div style={{ color: '#262626' }}>{channelName}</div>
					<div style={{ color: '#8c8c8c', fontSize: 12 }}>{channelType}</div>
				</div>
			</div>
		);
	}

	handleExport = async (values) => {
		const range = values.time_range || [];
		if (!values.channel_id || range.length !== 2) {
			this.props.notification({
				title: 'Xuất file TXT',
				content: 'Vui lòng chọn channel và khoảng thời gian',
				type: 'error'
			});
			return;
		}

		const fromDate = range[0].startOf('day').valueOf();
		const toDate = range[1].endOf('day').valueOf();
		if (fromDate > toDate) {
			this.props.notification({
				title: 'Xuất file TXT',
				content: 'Khoảng thời gian không hợp lệ',
				type: 'error'
			});
			return;
		}

		try {
			this.setState({ loading: true });
			const baseUrl = getEnv('REACT_APP_API_CHOTSALE_URL') || window.location.origin;
			const url = new URL(`${baseUrl}/api/v1/chat/export/txt`);
			url.searchParams.set('channel_id', values.channel_id);
			url.searchParams.set('from_date', fromDate);
			url.searchParams.set('to_date', toDate);
			await this.downloadBlob(url.toString());
			this.props.notification({
				title: 'Xuất file TXT',
				content: 'Tải file thành công',
				type: 'success'
			});
			this.setState({ loading: false });
		} catch (err) {
			this.setState({ loading: false });
			this.props.notification({
				title: 'Xuất file TXT',
				content: err.message || 'Đã có lỗi xảy ra',
				type: 'error'
			});
		}
	}

	render() {
		return (
			<div className="list-connect content-m">
				<div className="list-c">
					<Card title="Xuất hội thoại cho AI">
						<Spin spinning={this.state.loading || this.state.loadingChannels}>
							<Form
								layout="vertical"
								onFinish={this.handleExport}
								initialValues={{
									time_range: [moment().startOf('month'), moment().endOf('day')]
								}}
							>
								<Form.Item
									label="Channel"
									name="channel_id"
									rules={[{ required: true, message: 'Vui lòng chọn channel' }]}
								>
									<Select
										placeholder="Chọn channel"
										showSearch
										filterOption={(input, option) => {
											const keywords = String(option.keywords || '').toLowerCase();
											return keywords.includes(input.toLowerCase());
										}}
									>
										{this.state.channels.map((item) => {
											const meta = getChannelMeta(item);
											const channelName = getChannelName(item);
											const channelType = meta.name || 'Khác';
											return (
												<Option
													key={item.user_id}
													value={item.user_id}
													keywords={`${channelName} ${channelType}`}
												>
													{this.renderChannelOption(item)}
												</Option>
											);
										})}
									</Select>
								</Form.Item>

								<Form.Item
									label="Khoảng thời gian"
									name="time_range"
									rules={[{ required: true, message: 'Vui lòng chọn khoảng thời gian' }]}
								>
									<RangePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
								</Form.Item>

								<Form.Item style={{ marginBottom: 0 }}>
									<Button type="primary" htmlType="submit" loading={this.state.loading}>
										Xuất file txt
									</Button>
								</Form.Item>
							</Form>
						</Spin>
					</Card>
				</div>
			</div>
		);
	}
}
